import { date, showAlert } from '../../../lib/helpers';
import { headers, editedItem, defaultItem, search } from './attributes';

export default {
  data: () => ({
    search,
    dateMenu: false,
    dateMenuLastLogin: false,
    dateFormatted: '',
    dateFormattedLastLogin: '',
    show: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogView: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    editedItem,
    defaultItem,
    selectedRow: '',
    loadingDelete: false
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.users.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.users.flashError;
      },
      set() {
        this.$store.commit('users/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.users.errors;
    },
    loading() {
      return this.$store.state.users.loading;
    },
    users() {
      return this.$store.state.users.allUsers;
    },
    totalUsers() {
      return this.$store.state.users.totalUsers;
    },
    totalPage() {
      return this.$store.state.users.totalPage;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
    dialogDelete(val) {
      if (!val) {
        this.closeDelete();
      }
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.search.fullname = '';
        this.search.username = '';
        this.search.email = '';
        this.search.mobile_phone = '';
        this.search.last_login_at = '';
        this.search.role = '';
        this.search.status = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.fullname = '';
      this.search.username = '';
      this.search.email = '';
      this.search.mobile_phone = '';
      this.search.role = '';
      this.search.created_at = '';
      this.search.status = '';
      this.search.last_login_at = '';
    },

    getData() {
      this.$store.commit('users/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('users/fetchUsers', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      const dataItem = {
        ...item,
        user: { fullname: item.fullname, id: item.id },
      };
      this.editedIndex = this.$store.state.users.allUsers.indexOf(item);
      this.editedItem = { ...dataItem };
      this.editedIndex = -2;
      this.dialogView = true;
    },

    checkRole(item) {
      return item.id === this.editedItem.project.id;
    },

    addItem() {
      this.dialog = true;
    },

    editItem(item) {
      const dataItem = {
        ...item,
        user: { fullname: item.fullname, id: item.id },
      };

      this.editedIndex = this.$store.state.users.allUsers.indexOf(item);
      this.editedItem = { ...dataItem };
      this.dialog = true;
    },

    deleteItem(item) {
      const dataItem = {
        ...item,
        user: { fullname: item.fullname, id: item.id },
      };
      this.editedIndex = this.$store.state.users.allUsers.indexOf(item);
      this.editedItem = { ...dataItem };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loadingDelete = true;
      await this.$store
        .dispatch('users/deleteUser', {
          date,
          user: this.editedItem,
          index: this.editedItem.id,
        })
        .then((status) => {
          if (status) {
            this.loadingDelete = false;
            this.closeDelete();
            showAlert(
              this.$store,
              'Delete user success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            this.closeDelete();
            showAlert(
              this.$store,
              'Error on delete user !',
              'mdi-alert',
              'red'
            );
          }
        });
    },

    close() {
      this.resetUniqueValidation();
      this.dialogView = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    resetUniqueValidation() {
      this.$store.commit('users/clearErrors');
    },

    exportItem() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('users/exportList', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: 'user',
      });
    },
  },
};